export default {"src":"/_next/static/media/examples.1ef9de01.gif","height":607,"width":797,"blurWidth":0,"blurHeight":0};